import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import img_dummy from '../assets/images/dummy.png';

const TemplateImages = inject("stores") (
    observer (
        class TemplateImages extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.state = {
                    class_modifier: ''
                }

                this.storeUi = this.props.stores.storeUi;
            }

            componentDidMount = () => {
                let class_modifier = "--amount-" + this.props.amount;

                this.setState({
                    amount: this.props.amount,
                    class_modifier: class_modifier
                })
            }

            getImages = () => {
                let content = [];
                for (let i = 0; i < this.state.amount; i++) {
                    content.push(<div className='grid-images__image'><img src={img_dummy} /></div>);
                };
                
                return content;
            }

            render() {
                return (
                    <React.Fragment>
                        <div className={"grid-images grid-images" + this.state.class_modifier}>
                            {this.getImages()}
                        </div>
                    </React.Fragment>
                );
            }
        }
    )
)

export default TemplateImages;
